.notice {
  display: flex;
  gap: var(--space-3);
  align-items: flex-start;
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-control);
  border: 1px solid;
  font-size: var(--text-sm);
}

.notice svg {
  flex: none;
  width: 18px;
  height: 18px;
  margin-top: 2px;
}

.info {
  background: var(--color-surface-soft);
  border-color: var(--color-border);
  color: var(--color-ink);
}

.warning {
  background: var(--color-warning-soft);
  border-color: #e9c98f;
  color: var(--color-warning-ink);
}

.error {
  background: var(--color-danger-soft);
  border-color: #e6a9ad;
  color: var(--color-danger);
}

.success {
  background: var(--color-success-soft);
  border-color: #a9d3b8;
  color: var(--color-success);
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.title {
  font-weight: 600;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--space-3);
  padding: var(--space-8) var(--space-6);
  color: var(--color-muted);
}

.empty h3 {
  color: var(--color-ink);
  font-family: var(--font-display);
  font-weight: 400;
  font-size: var(--text-xl);
}
